import React from "react";

const Title = ({className, content}) => {
    return (
        <h1 className={className}>
            {content}
        </h1>
    )
}

export default Title 